import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { UserContext } from './UserContext';
import { registerPushNotifications } from './serviceWorkerRegistration';
import { Button, Menu, MenuItem, Box } from '@mui/material';

const Header = () => {
  const { user } = useContext(UserContext);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    // Supprimez le token d'authentification du stockage local
    localStorage.removeItem('token');

    // Redirigez l'utilisateur vers la page de connexion
    window.location.href = '/';
  };

  const handleSubscribe = async () => {
    await registerPushNotifications();
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 2, bgcolor: '#333', color: '#fff' }}>
      <Box>
        <ul style={{ display: 'flex', padding: 0, listStyle: 'none' }}>
          <li><Link to="/" style={{ color: '#fff', marginRight: '15px' }}>Accueil DEMO</Link></li>
          {user && <li><Link to="/recipes/create" style={{ color: '#fff' }}>Créer une recette</Link></li>}
        </ul>
      </Box>

      <Box>
        <Button onClick={handleMenuClick} sx={{ color: '#fff' }}>Utilisateur</Button>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleCloseMenu}
        >
          {!user && <MenuItem onClick={handleCloseMenu}><Link to="/signup" style={{ textDecoration: 'none', color: '#000', width: '100%' }}>Inscription</Link></MenuItem>}
          {!user && <MenuItem onClick={handleCloseMenu}><Link to="/login" style={{ textDecoration: 'none', color: '#000', width: '100%' }}>Connexion</Link></MenuItem>}
          {user && <MenuItem onClick={handleCloseMenu}><Link to="/profile" style={{ textDecoration: 'none', color: '#000', width: '100%' }}>Profil</Link></MenuItem> }
          {user && (
            <MenuItem onClick={handleLogout} style={{ textDecoration: 'none', color: '#000', width: '100%' }}>Déconnexion</MenuItem>
          )}
          {user && (
            <MenuItem onClick={handleSubscribe} style={{ textDecoration: 'none', color: '#000', width: '100%' }}>S'abonner aux notifications</MenuItem>
          )}
        </Menu>
      </Box>
    </Box>
  );
};

export default Header;